import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { SearchFilter } from '@backstage/plugin-search-react';
import { SearchFilterBlueprint } from '@backstage/plugin-search-react/alpha';

// Only Software Catalog and TechDocs documents carry a `system` field
// (see packages/backend/src/extensions/search/*SystemSearchField.ts), so
// this filter narrows those two result types only. ADRs, Announcements,
// and Azure DevOps Wiki results are unaffected either way.
export const systemSearchFilter = SearchFilterBlueprint.make({
  params: {
    component: ({ className }) => {
      const catalogApi = useApi(catalogApiRef);
      return (
        <SearchFilter.Autocomplete
          className={className}
          label="System"
          name="system"
          values={async () => {
            const { items } = await catalogApi.getEntities({
              filter: { kind: 'System' },
              fields: ['metadata.name', 'metadata.title'],
            });
            return items
              .map(entity => ({
                value: entity.metadata.name,
                label: entity.metadata.title ?? entity.metadata.name,
              }))
              .sort((a, b) => a.label.localeCompare(b.label));
          }}
        />
      );
    },
  },
});
